import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * CustomSelects - применяет к элементу с аттрибтом custom-select niceSelect
 */
export class CustomSelectsBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('custom-select');
    }

    protected installBehaviour(element: HTMLElement): void {
        if (
            (<any>window).globalAppSettings.isMobileDevice &&
            !(<any>window).globalAppSettings.isMobileDeviceInDesktopMode
        ) {
            return;
        }

        if ($.fn.niceSelect) {
            (<any>$(element)).niceSelect();
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.CustomSelectsBehaviour = CustomSelectsBehaviour;